// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"4ab87002","718":"6d20da5d"}[chunkId] + ".chunk.css";
};